import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import { MILEAGE_METRIC } from 'constant'
import {
  CompactTrailerImage,
  CompactVehicleImg,
  CompactVehicleNickname,
  CompactVehicleYMME,
  CompactMileageWrapper,
  CompactMileageValue,
  CompactEditIcon
} from 'components/MyGarage2.0/components/SharedStyles'
import { addCommas, isNicknamePersonalized, isNicknameDuplicate, withNicknameSufix } from 'components/MyGarage2.0/helpers'

const CompactVehicleInfo = ({
  className,
  mileage,
  vehicleNickname,
  vehicleName,
  vehicleColor,
  masterVehicle: {
    makeDesc,
    modelDesc,
    subModelDesc,
    yearDesc
  } = {},
  formattedTireSize,
  isTrailer,
  isGenericTrailer,
  openEditMileageModal,
  navigateToVehicleDetailsPage
}) =>
  <InfoWrapper className={ className }>
    <ImgWrapper>
      { (isTrailer || isGenericTrailer) ?
        <CompactTrailerImage asset="icon-trailer" alt={ 'Trailer' } /> :
        <CustomCompactVehicleImg
          year={ parseInt(yearDesc, 10) }
          make={ makeDesc }
          model={ modelDesc }
          submodel={ subModelDesc }
          color={ vehicleColor ? `#${vehicleColor}` : undefined }
          height={ 40 }
          width={ 100 }
          onClick={ navigateToVehicleDetailsPage } /> }
    </ImgWrapper>
    <div>
      { isGenericTrailer ?
        <VehicleNickname>
          { vehicleName }
        </VehicleNickname> :
        <VehicleNickname clickable onClick={ navigateToVehicleDetailsPage }>
          { isNicknamePersonalized(vehicleName, vehicleNickname) ?
            vehicleNickname :
            isNicknameDuplicate(vehicleNickname) ? withNicknameSufix(vehicleNickname) : `${yearDesc} ${makeDesc}` }
        </VehicleNickname>
      }
      { isTrailer &&
        <VehicleYMME>
          { formattedTireSize }
        </VehicleYMME>
      }
      { (!isTrailer && !isGenericTrailer) &&
        <VehicleYMME clickable onClick={ navigateToVehicleDetailsPage }>
          { isNicknamePersonalized(vehicleName, vehicleNickname) ? vehicleName : `${modelDesc} ${subModelDesc}` }
        </VehicleYMME>
      }
      { (!isTrailer && !isGenericTrailer) &&
      <CompactMileageWrapper>
        <CompactMileageValue>
          { `${addCommas(mileage)} ${MILEAGE_METRIC}` }
        </CompactMileageValue>
        <CompactEditIcon
          asset="edit-red"
          alt="Edit Vehicle Button"
          tabIndex="0"
          onClick={ openEditMileageModal } />
      </CompactMileageWrapper> }
    </div>
  </InfoWrapper>

export default CompactVehicleInfo

CompactVehicleInfo.propTypes = {
  className: PropTypes.string,
  formattedTireSize: PropTypes.string,
  isGenericTrailer: PropTypes.bool,
  isTrailer: PropTypes.bool,
  masterVehicle: PropTypes.shape({
    makeDesc: PropTypes.string,
    modelDesc: PropTypes.string,
    subModelDesc: PropTypes.string,
    yearDesc: PropTypes.string
  }),
  mileage: PropTypes.string,
  navigateToVehicleDetailsPage: PropTypes.func,
  openEditMileageModal: PropTypes.func,
  vehicleColor: PropTypes.string,
  vehicleName: PropTypes.string,
  vehicleNickname: PropTypes.string
}

export const InfoWrapper = styled.div`
  display: flex;
`

export const ImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Theme.colors.white_smoke};
  width: 100px;
  height: 90px;
  margin-right: 19px;
`

const CustomCompactVehicleImg = styled(CompactVehicleImg)`
  cursor: pointer;
`

const VehicleNickname = styled(CompactVehicleNickname)`
  ${props => props.clickable && css`
    cursor: pointer;
  `}
`

const VehicleYMME = styled(CompactVehicleYMME)`
  ${props => props.clickable && css`
    cursor: pointer;
  `}
`
